import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  apiChinaMobilProtocol,
  apiEncryption,
  apiGetCardPool,
  apiGetGoodsDetail,
  apiGetMatchById,
  apiGetOpenId,
  apiGetPayConfigList,
  apiGetWeChatSignature,
  apiGoodsLandingPageLink,
  apiMarketOfferOrder,
  apiMarketVerifyCode,
  apiOssUpload,
  apiPayAndSubmitOrder,
  apiSubmitOrder,
  marketSelectToken,
  queryCarryPrice,
} from '../api';
import AppBar from '../components/appBar';
import CountdownTimer from '../components/countdown_timer';
import Empty from '../components/empty';
import GoodsShareModal from '../components/goods-share';
import Loading from '../components/loading';
import MessageDialog from '../components/messageDialog';
import MCityPicker from '../components/m_city_picker/m_city_picker';
import NotWxPageDialog from '../components/notWxPageDialog';
import Page from '../components/page';
import ProtocolDialog from '../components/protocolDialog';
import MCheckbox from '../components/radioBox';
import ReminderDialog from '../components/reminderDialog';
import MSelectbox from '../components/select';
import SelectPhoneDialog from '../components/selectPhoneDialog';
import ViewPictureDialog from '../components/viewPictureDialog';
import XzprotocolDialog from '../components/xzProtocolDialog';
import ZyProtocolDialog from '../components/zyProtocolDialog';
import main from '../main';
import { Goods, PayConfig, Privacy } from '../types';
import { getLandingPageNumber, getSafeLandingLink } from '../utils/landingPage';
import showPayPage, { PayType } from '../utils/pay';
import { operatorsTypeData } from '../utils/source';
import {
  copyToClipboard,
  dictLabel,
  isWeixinEnv,
  parseLocationParams,
  showConfirm,
  showToast,
  xzPageCode,
} from '../utils/utils';
import { protocolData } from './protocolPage';

let xzWindow: any = window;
let loading = false;
// 广东移动埋码
let insertCode = {
  businessType_var: '放号',
  goodsType_var: '号卡',
  apiId_var: '',
  apiName_var: '',
  merchantsId_var: 'GDOPEN_2116613', // 商品所属商户id。
  merchantsIdCity_var: '省统', //商户ID归属地市，枚举值：省统、广州、中山、云浮……
  merchants_var: '河南天诺信息技术有限公司', // 商品所属商户名称。
  contactNumber_var: '', //输入电话号码,传AES加密后的手机号
  selectNumber_var: '', // 办理号码(需AES加密),传用户要购买的那个号码
  errorMessage_var: '', // 业务办理失败时的失败原因明细
  channelId_var: '', // 下单渠道编码
  operatorId_var: '', // 下单工号
  payType_var: '', // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
  merchantsOrder_var: '', // 自建的订单号。
  orderNumber_var: '', // 能开接口返回的订单号。
  ordertype_var: '号卡订单', // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
};
// 隐私协议数据
let xzProtocolList: Privacy[] = [
  {
    protocolName: '中国移动通信客户入网服务协议',
    content: 'https://oss.cmtibet.com/activity/2020/haokaoxiaoshou/bg-39.png',
  },
  { protocolName: '中国移动通信业务受理', content: '/pic/xieyi2.jpg' },
  {
    protocolName: '电话卡合规使用告知书',
    content: 'https://oss.cmtibet.com/activity/2020/haokaoxiaoshou/bg-109.png',
  },
  {
    protocolName: '关于依法清理整治涉诈电话卡、物联网卡以及关联互联网账户的通告',
    content: 'https://oss.cmtibet.com/activity/2020/haokaoxiaoshou/bg-111.png',
  },
  { protocolName: '反电信网络诈骗提示书', content: '/pic/xieyi5.jpg' },
];
let isreminderDialogShow = sessionStorage.getItem('reminderDialogShow') || undefined;
export default function DetailPage() {
  const ref = useRef<{ timer?: NodeJS.Timeout; count?: number }>({});
  let location = useLocation();
  const { state } = useLocation();
  const navigate = useNavigate();
  let landingCode = sessionStorage.getItem('landingCode') ?? '';

  const [goodsDetail, setGoodsDetail] = useState<Goods>();
  const [loadError, setLoadError] = useState('');
  const [sharePosterShow, setsharePosterShow] = useState<Goods>();
  // 分享链接
  const [shareUrl, setshareUrl] = useState();
  // 已选卡号
  const [selectCard, setSelectCard] = useState<{
    activatePhone: string;
    checkCode: string;
    phoneSessionId?: string;
    phoneTag?: string;
    numberPoolId?: string;
    numberId?: string;
  }>();
  // 开卡号码
  const [activatePhone, setactivatePhone] = useState('');
  // 身份证名
  const [cardName, setCardName] = useState('');
  // 身份证号
  const [cardNum, setCardNum] = useState('');
  // 收件人手机号
  const [phone, setPhone] = useState('');
  // 验证码
  const [verifyCode, setVerifyCode] = useState('');
  const [sendCaptcha, setSendCaptcha] = useState(0);
  // 省市区
  const [province, setProvince] = useState('');
  // 市区
  const [city, setCity] = useState('');
  // 区
  const [area, setArea] = useState('');
  // 地址
  const [address, setAddress] = useState('');
  // 运营商
  const [operatorsType, setoperatorsType] = useState('');
  // 身份证头像照片
  const [cardAvatar, setCardAvatar] = useState<string>();
  // 身份证国徽照片
  const [cardNationalEmblem, setNationalEmblem] = useState<string>();
  // 免冠正面照片
  const [handPhoto, setHandPhoto] = useState<string>();
  // 自定义照片
  const [definedPhotoImg, setdefinedPhotoImg] = useState<string>();
  // 已选同意协议
  const [checkProtocol, setCheckProtocl] = useState(false);
  // 显示协议弹窗
  const [showProtocol, setShowProtocol] = useState<string>();
  // 显示选择卡号弹窗
  const [showSelectCardDialog, setShowSelectCardDialog] = useState(false);
  // 运营商数据
  const [operatorsList, setoperatorsList] = useState<{ value: string; label: string }[]>([]);
  // 是否隐藏appbar 默认不隐藏 app内嵌入网页时可设置 h=1 隐藏
  const [hideAppBar, setHideAppBar] = useState(false);
  /**
   * activatePhone :  17260779503
   * checkCode : dGcoEdX1DCNUYjXy4
   */
  const [cardPool, setCardPool] = useState([]);
  const [urlQueryParams, setUrlQueryParams] = useState<any>({});
  // 支付配置列表
  const [payConfigList, setPayConfigList] = useState<PayConfig[]>([]);
  const [payType, setPayType] = useState('');
  // 微信支付配置准备完成
  const [, setWxReady] = useState(false);
  // 判断视频上的播放图片是否显示
  const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(true);
  const [selectPhoneFlag, setselectPhoneFlag] = useState<boolean>(true);
  // 短信验证码orderId
  const [smsKey, setSmsKey] = useState();
  // 路路通productId
  const [productId, setproductId] = useState<string>('');
  // 接口报错msg
  const [messageDialogShow, setmessageDialogShow] = useState<string>('');
  // 地址库数据
  const [matchList, setMatchList] = useState([]);
  // 上传照片显示loading
  const [uploadLoading, setuploadLoading] = useState<boolean>(false);
  // 查看图片
  const [viewPictureDialogShow, setviewPictureDialogShow] = useState<string | undefined>();
  const [title, settitle] = useState<string | undefined>();
  // 加密手机号
  const [aesPhone, setaesPhone] = useState<string>();
  // 获取商品接口报错
  const [detailerrorMsg, setDetailerrorMsg] = useState<string>('');
  // 是否需要请求协议
  const [protocolFlag, setprotocolFlag] = useState<boolean>(false);
  // 隐私协议数据
  const [privacyAgreementData, setprivacyAgreementData] = useState<Privacy[]>([]);
  // 点击的隐私协议
  const [protocolcontent, setprotocolcontent] = useState<Privacy>();
  // 温馨提示
  const [reminderDialogShow, setreminderDialogShow] = useState<boolean>(!isreminderDialogShow || true);

  // 点击的西藏隐私协议
  const [xzprotocolcontent, setxzprotocolcontent] = useState<Privacy>();
  // jdk获取toekn
  const [token, settoken] = useState<string>('');
  // 有效期倒计时
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    main.enterUrl = window.location.href;
    // 微信code 和商品code参数冲突，改商品code为id自动跳转
    let _p = parseLocationParams(location.search) ?? {};
    setUrlQueryParams(_p);

    if (_p.code?.length === 10) {
      let queryStr = location.search.replaceAll('code=', 'id=');
      window.location.replace(window.location.origin + window.location.pathname + '/' + queryStr);
    } else if (isWeixinEnv()) {
      // 获取支付列表
      loadPayConfigList(_p.id);
      loadGoodsDetail(_p.id);
    } else {
      // 非微信环境内（浏览器、支付宝直接获取商品详情与支付方式）
      loadGoodsDetail(_p.id);
      loadPayConfigList(_p.id);
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (protocolFlag && !!province) {
      getProtocol();
    }
  }, [protocolFlag, province]); // eslint-disable-line
  useEffect(() => {
    if (isWeixinEnv()) {
      wxConfig();
    }
  }, []);
  async function wxConfig() {
    // @ts-ignore
    let wx = window.wx;
    // 不写ready方法了，因为使用wx-open-launch-weapp的时候是在最终用户点了去支付按钮后 必定ready了
    let res = await apiGetWeChatSignature(
      main.isIos14 ? main.enterUrl : window.location.href.split('#')[0],
      main.appId
    );
    let data = res.data;
    if (data.code === 200) {
      let _data = data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: main.appId, // 必填，公众号的唯一标识
        timestamp: _data.timestamp, // 必填，生成签名的时间戳
        nonceStr: _data.nonceStr, // 必填，生成签名的随机串
        signature: _data.signature, // 必填，签名
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp', 'checkJsApi'],
      });
    }
  }
  // 获取OPENID
  async function getOpenId(id: string) {
    try {
      let res = await apiGetOpenId(main.code!, main.appId, id);
      let data = res.data;
      if (data.code === 200) {
        main.openId = data.data;
        localStorage.setItem(main.appId, main.openId ?? '');

        loadGoodsDetail(urlQueryParams.id);
      }
    } catch (e) { }
  }

  function wxPayReady() {
    if (!isWeixinEnv()) return;
    // @ts-ignore
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => setWxReady(true), false);
        // @ts-ignore
      } else if (document.attachEvent) {
        // @ts-ignore
        document.attachEvent('WeixinJSBridgeReady', () => setWxReady(true));
      }
    } else {
      setWxReady(true);
    }
  }

  // 获取支付列表
  async function loadPayConfigList(code?: string) {
    try {
      let res = await apiGetPayConfigList(code ?? urlQueryParams.id);
      let data = res.data;
      if (data.code === 200) {
        let _list = data.data ?? [];
        // let _list: any = [
        //   {
        //     "id": "1931911345448527777",
        //     "deptId": null,
        //     "deptName": null,
        //     "name": "微信支付3",
        //     "pageType": null,
        //     "status": null,
        //     "sortNum": null,
        //     "remark": null,
        //     "appId": null,
        //     "payType": "yh_wx_web"
        //   },
        //   {
        //     "id": "1931911345448529988",
        //     "deptId": null,
        //     "deptName": null,
        //     "name": "微信支付2",
        //     "pageType": null,
        //     "status": null,
        //     "sortNum": null,
        //     "remark": null,
        //     "appId": "wx325d2f7c68fc6349",
        //     "payType": "lft"
        //   }
        // ]
        let arr: any[] = [];
        if (isWeixinEnv()) {
          arr = _list.filter((i: { payType: string }) => {
            return i.payType.indexOf('wechatJsPay') !== -1 ||
              i.payType.indexOf('jsd_h5_wx') !== -1 ||
              i.payType.indexOf('jsd_h5_ali') !== -1
              || i.payType.indexOf('lft') !== -1
              || i.payType.indexOf('yh_ali_web') !== -1
              || i.payType.indexOf('yh_wx_web') !== -1;

          });
          main.appId = arr[0]?.appId ?? '';
          let param = parseLocationParams(location.search);
          // 对比appid和链接内是否一样
          if (main.appId) {
            // if (main.appId !== param.appId) {
            //   // 跳转自身带上appid
            //   param.appId = main.appId;
            //   let url = Object.keys(param)
            //     .map((key) => `${key}=${param[key]}`)
            //     .join('&');
            //   let path = window.location.origin + window.location.pathname + `?${url}`;
            //   window.location.replace(path);
            // } else {
            let openId = localStorage.getItem(main.appId);
            if (!!openId) {
              main.openId = openId;
              loadGoodsDetail(urlQueryParams.id);
            } else {
              //  判断是否有CODE
              if (!!param.code) {
                main.code = param.code;
                getOpenId(arr[0]?.id);
              } else {
                let redirect_uri = encodeURIComponent(window.location.href);
                // 没有取到缓存openId, 跳微信链接
                document.location.replace(
                  `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${main.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
                );
              }
              // }
            }
          }
          // 用appID 取缓存openID 跳转自身带上appid
        } else {
          arr = _list.filter((i: { payType: string }) => i.payType.indexOf('jsd_h5_ali') !== -1 ||
            i.payType.indexOf('lft') !== -1 || i.payType.indexOf('yh_ali_web') !== -1 || i.payType.indexOf('yh_wx_web') !== -1);
        }
        setPayConfigList(arr);
        if (arr.length > 0) {
          setPayType(arr[0].payType);
        }
      }
    } catch (e) { }
  }

  async function loadGoodsDetail(code: string) {
    wxPayReady();
    let _p = parseLocationParams(location.search) ?? {};
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    try {
      let res = await apiGetGoodsDetail(code ?? _p.id, _p?.ci, _p?.sn ?? shopNum);
      let data = res.data;
      if (data.code === 200) {
        setGoodsDetail(data.data);
        if (data.data?.goodsType === 'order_subscribe') {
          window.location.href = `https://h5.100861.net/ys/?${data.data.goodsCode}`;
        }
        // 带参数的和路路通的都隐藏
        let _hideTitle = _p.h === '1' || !!_p.productId;
        if (_p.productId) {
          setproductId(_p.productId);
        }
        setHideAppBar(_hideTitle);
        if (landingCode) {
          main.setShopId(landingCode);
        } else if (data.data?.shopId) {
          main.shopId = (parseInt(data.data?.pageType ?? '0') !== 0 ? data.data.pageType : '') + data.data.shopId;
        }

        if (data.data.supId) {
          getMatchById(data.data.supId);
          setprotocolFlag(main.protocolList.includes(data.data.supId));
        }

        if (data.data.ifCampOn === 'Y' && data.data.ifAddress !== 'Y') {
          loadCardPool(data.data.goodsCode);
        }
        // 商品类型不等于号卡时获取运营商数据
        if (data.data?.goodsType !== 'order') {
          let _data = [
            { label: '中国移动', value: 'cmcc' },
            { label: '中国联通', value: 'unicom' },
            { label: '中国电信', value: 'telecom' },
            { label: '中国广电', value: 'cbn' },
          ];
          let list = data.data.operatorsType ? data.data.operatorsType.split(',') : [];
          let _list: any = [];
          list.forEach((item: string) => {
            _data.forEach((i) => {
              if (item === i.value) {
                _list.push(i);
              }
            });
          });
          setoperatorsList(_list);
          setoperatorsType(_list[0]?.value);
        }
        // 广东移动插码初始化开始----
        if (main.supId === data?.data?.supId) {
          window.gdp('init', '8d2279a5e2f18b7c', '9d59ac736f01c688', {
            host: 'collect.gmcc.net', // 数据发送地址。
            compress: true, // 开启数据压缩模式。
            // debug: true, // 开启测试模式，控制台可看到数据，生产环境请勿添加此参数。
            hashtag: true, //开启页面URL混淆采集
            scheme: 'https', //http页面加此参数
          });
          window.gdp('setGeneralProps', {
            global_merchantsId_var: 'GDOPEN_2116613', // 商户id
            global_merchants_var: '河南天诺信息技术有限公司', // 商户名称
            global_apiId_var: 'smscodechkodcommitorder', // 接口id；传产品受理的接口ID
            global_apiName_var: '短信验证及订单提交', // 调用接口名称；传产品受理的接口名称
            global_merchantsIdCity_var: '省统', //商户ID归属地市，枚举值：省统、广州、中山、云浮……
          });
          window.gdp(
            'track',
            'merchants_bussinessProcessing',
            Object.assign({}, insertCode, {
              goodsId_var: data?.data?.skuCode, // 业务办理时所属的商品ID。（需与能开商品编码一致）
              goodsName_var: data?.data?.skuName, //业务办理时商品名称。
              processType_var: '页面浏览', // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
            })
          );
        }
        // 广东移动插码开始初结束----
        // TODO:西藏移动插码初始化开始-----
        if (main.xzSupIds.includes(data?.data?.supId)) {
          if (xzWindow?._pagecode) {
            xzWindow?._pagecode.init({
              channel: '911004980',
            });
            submitXzPageCode('1', '首页');
          }
        }
        // 西藏移动插码初始化结束-----
      } else if (data.code === 503) {
        setLoadError(data?.msg ?? '暂未找到商品');
      } else {
        // setLoadError(data.msg ?? '暂未找到商品');
        setDetailerrorMsg(data.msg ?? '暂未找到商品');
      }
    } catch (e: any) {
      setLoadError(e?.message ?? '暂未找到商品');
    }
  }
  // 获取协议
  async function getProtocol() {
    try {
      let res = await apiChinaMobilProtocol({ goodsCode: goodsDetail?.goodsCode, provenceName: province });
      let data = res.data;
      if (data.code === 200) {
        setprivacyAgreementData(data.data.protocolList);
      } else {
        setprivacyAgreementData([]);
      }
    } catch (e: any) {
      showToast(e.message ?? '获取协议失败,请重试');
    }
  }

  async function getMatchById(supId: string) {
    try {
      let res = await apiGetMatchById(supId);
      let data = res.data;
      if (data.code === 200) {
        setMatchList(data.data);
      } else {
        setMatchList([]);
      }
    } catch (e: any) {
      showToast(e.message ?? '获取可选号码失败,请重试');
    }
  }

  async function loadCardPool(code: string, _p?: string, _v?: string, _c?: string) {
    setSelectCard(undefined);
    setCardPool([]);
    try {
      let res = await apiGetCardPool(code, _p, _v, _c);
      let data = res.data;
      if (data.code === 200) {
        setCardPool(data.data);
        setselectPhoneFlag(true);
      } else {
        setselectPhoneFlag(false);
        setmessageDialogShow(data.msg ?? '获取可选号码失败,请重试');
      }
    } catch (e: any) {
      showToast(e.message ?? '获取可选号码失败,请重试');
    }
  }

  function handleCityPickerChange(v: string[]) {
    if (v[0] === '暂无可选城市') return;
    setProvince(v[0]);
    setCity(v[1]);
    setArea(v[2]);
    handChangeIpt('选择收货地址');
    if (goodsDetail?.ifAddress === 'Y') {
      loadCardPool(goodsDetail?.goodsCode, v[0], v[1], v[2]);
    }

    getCarryPrice(v[0], v[1]);
  }
  async function getCarryPrice(pro: string, city: string) {
    let _p = parseLocationParams(location.search) ?? {};
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    const res = await queryCarryPrice({ code: _p?.id, province: pro, city, shopNum: urlQueryParams?.sn ?? shopNum });
    if (res?.code === 200) {
      if (goodsDetail) {
        setGoodsDetail({
          ...goodsDetail,
          carryPrice: res?.data?.carryPrice || goodsDetail?.carryPrice || 0,
        });
      }
    }
  }
  // 不能有数字、字母、特殊符号（不包含少数民族名字中的点）、不能一个字
  function isValidName(name: string) {
    // 允许的少数民族名字中的点（例如：·）
    const allowedDots = /[·]/;
    // 校验姓名是否包含不允许的字符
    const regex = /^[^0-9a-zA-Z!！，、。@#$%^&*()_+\-=【】[{};':"\\|,.<>/?]+$/;
    if (name.length <= 1) {
      return false;
    } else {
      // 检查是否包含不允许的点（如果不是允许的点）
      if (!allowedDots.test(name)) {
        return regex.test(name);
      } else {
        // 替换掉所有非允许的点后校验
        const nameWithoutInvalidDots = name.replace(/[^·]/g, '');
        return regex.test(nameWithoutInvalidDots);
      }
    }
  }

  // 校验详细地址是否包含省/市/区信息
  function validateAddress() {
    if (province.includes('市')) return true;
    const shouldValidate = !!province && !!city;
    if (!shouldValidate) {
      return true;
    }
    // 过滤非空的省市关键词
    const locationCores = [province, city].filter(Boolean);
    // 检查详细地址是否包含任一关键词
    const hasDuplicate = locationCores.filter((core) => address.includes(core));

    if (hasDuplicate.length === locationCores.length) {
      showToast('已选择省/市信息，请勿在详细地址再次输入省、市等信息！');
      return false;
    }
    return true;
  }

  // 获取token
  async function getToken() {
    try {
      const res = await marketSelectToken({ data: 'kgj' });
      if (res.code === 200) {
        settoken(res.data);
        return res.data;
      } else {
        showToast(res.msg ?? '获取token失败');
      }
    } catch (error) { }
  }
  // 中移号卡需加载sdk
  async function isChinaMobileGoods() {
    if (goodsDetail?.chinaMobileGoods === 'Y') {
      // @ts-ignore
      return window.channelSDK() && window.channelSDK().then((d: string) => getToken());
    } else return null;
  }

  // 西藏移动初始化
  function initXzPageCode() {
    // TODO:等运营商通知可外网访问后解注
    if (main.xzSupIds.includes(goodsDetail?.supId!)) {
      let phoneEncrypt = xzWindow.___phonecodeEncrypt.encodeMobile(phone);
      xzWindow?._pagecode &&
        xzWindow?._pagecode.init({
          user: phoneEncrypt,
          // user: '',
        });
    }
  }
  // 提交西藏移动插码数据 step：当前办理步骤 eventCode=业务步骤码
  async function submitXzPageCode(step: string, eventCode: string) {
    // TODO:等运营商通知可外网访问后解注
    xzPageCode(goodsDetail?.supId!, '', eventCode ?? '', {
      stepNo: step,
      goodsName: goodsDetail?.goodsName,
      goodsPrice: goodsDetail?.goodsPrice,
    });
  }

  async function handleSubmit() {
    if (!validateAddress()) return;
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    let interceptArr = ['酒店', '宾馆', '网吧', '驿站'];
    let idx = interceptArr.findIndex((i) => !address.indexOf(i));
    /// 身份证正则
    const cardNumReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (isSimpleMode) {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(phone)) {
        return showToast('请输入正确的收件号码');
      }
    } else {
      if (goodsDetail?.goodsType === 'order_subscribe' && !activatePhone) {
        return showToast('请输入开卡号码');
      }
      if (goodsDetail?.ifCampOn === 'Y' && !selectCard) {
        return showToast('请选择号码');
      }
      if (operatorsList.length > 0 && goodsDetail?.goodsType && goodsDetail?.goodsType !== 'order' && !operatorsType) {
        return showToast('请选择运营商');
      }
      if (!isValidName(cardName)) {
        return showToast('请输入身份证名');
      }
      if (
        !cardNum &&
        (goodsDetail?.goodsType === 'order' ||
          goodsDetail?.goodsType === 'order_subscribe' ||
          goodsDetail?.goodsType === 'broadband')
      ) {

        return showToast('请输入身份证号');
      } else if (
        (goodsDetail?.goodsType === 'order' ||
          goodsDetail?.goodsType === 'order_subscribe' ||
          goodsDetail?.goodsType === 'broadband') &&
        !cardNumReg.test(cardNum)
      ) {
        return showToast('请输入正确的身份证号');
      }
      let reg = /^1[3456789]\d{9}$/;
      if (goodsDetail?.goodsType !== 'order_subscribe' && !reg.test(phone)) {
        return showToast('请输入正确的收件号码');
      }
      if (goodsDetail?.goodsType !== 'order_subscribe' && !province) {
        return showToast('请选择省市区');
      }
      if (goodsDetail?.goodsType !== 'order_subscribe' && !address) {
        return showToast('请输入详细地址');
      }
      if (goodsDetail?.goodsType !== 'order_subscribe' && goodsDetail?.goodsType !== 'equipment' && idx !== -1) {
        return showToast(`详细地址不能包含${interceptArr[idx]}`);
      }
      if (goodsDetail?.ifPhoto === 'Y' && !cardAvatar) {
        return showToast('请上传身份证头像照片');
      }
      if (goodsDetail?.ifPhoto === 'Y' && !cardNationalEmblem) {
        return showToast('请上传身份证国徽照片');
      }
      if (goodsDetail?.ifPhoto === 'Y' && !handPhoto) {
        return showToast('请上传免冠正面照片');
      }
      if (goodsDetail?.isDefinedPhoto === 'Y' && !definedPhotoImg) {
        return showToast('请上传照片');
      }
      if (!checkProtocol) {
        return showToast('请阅读并同意协议');
      }
    }
    if (loading) {
      return;
    }
    loading = true;
    initXzPageCode();
    // 西藏移动插码-提交办理
    submitXzPageCode('21', '确认办理');
    let submitOverTips = '';
    if (goodsDetail?.supId === main.supId) {
      window.gdp(
        'track',
        'merchants_bussinessProcessing',
        Object.assign({}, insertCode, {
          goodsId_var: goodsDetail?.skuCode, // 业务办理时所属的商品ID。（需与能开商品编码一致）
          goodsName_var: goodsDetail?.skuName, //业务办理时商品名称。
          apiId_var: 'AirpickinstallnewOrder', // 调用能开接口id。（调用能开接口时赋值）
          apiName_var: '线上放号订单下单接口', // 调用能开接口名称。（调用能开接口时赋值）
          contactNumber_var: aesPhone, //联系电话(AES加密后的手机号),传用户的联系电话
          processType_var: '提交订单', // 业务办理时的每个办理步骤。（页面浏览、输入姓名(点击输入框时触发）、输入联系电话(点击输入框时触发）、输入身份证(点击输入框时触发）、选择收货省/市（选择成功后触发）、选择号码归属（选择成功后触发）、选择号码（选择号码成功后触发）、选择收货地址（选择成功后触发）、填写详细地址(点击输入框时触发）、提交订单、提交订单成功、提交订单失败......）
        })
      );
    }

    let _p = parseLocationParams(location.search) ?? {};
    let _token = await isChinaMobileGoods();
    let orderData = {
      goodsId: goodsDetail!.id,
      cardName,
      cardNo: cardNum,
      receiverName: cardName,
      receiverPhone: phone,
      province,
      city,
      county: area,
      address,
      activatePhone: goodsDetail?.goodsType === 'order_subscribe' ? activatePhone : selectCard?.activatePhone,
      avatarImg: cardAvatar,
      nationalEmblemImg: cardNationalEmblem,
      handPhotoImg: handPhoto,
      operatorsType: operatorsType,
      shopNum: urlQueryParams?.sn ? urlQueryParams?.sn : shopNum,
      definedPhotoImg,
      apiParams: Object.assign({}, urlQueryParams ?? {}, {
        preCityCode: selectCard?.checkCode,
        checkCode: selectCard?.checkCode,
        code: _p.id,
        phoneSessionId: selectCard?.phoneSessionId,
        phoneTag: selectCard?.phoneTag,
        numberId: selectCard?.numberId,
        numberPoolId: selectCard?.numberPoolId,
        zxticketshu: _token ? _token : token,
      }),
    };

    // 非支付订单
    if (goodsDetail?.paySwitch !== 'Y' && Number(goodsDetail?.carryPrice) <= 0) {
      try {
        let res = await apiSubmitOrder(orderData);
        let data = res.data;
        if (data.code === 200) {
          submitOverTips = data.msg ?? '提交成功';
          // 河南广电需要跳转广电的支付页面进行支付
          let payUrl = data.data?.payUrl;
          if (!!payUrl) {
            window.location.href = payUrl;
          } else if (!!data?.data?.supUrl) {
            window.location.replace(data?.data?.supUrl);
          } else {
            navigate('/submit', { state: submitOverTips });
          }
          if (goodsDetail?.supId === main.supId) {
            window.gdp(
              'track',
              'merchants_bussinessProcessing',
              Object.assign({}, insertCode, {
                goodsId_var: goodsDetail?.skuCode, // 业务办理时所属的商品ID。（需与能开商品编码一致）
                goodsName_var: goodsDetail?.skuName, //业务办理时商品名称。
                contactNumber_var: aesPhone, //联系电话(AES加密后的手机号),传用户的联系电话
                processType_var: '提交订单成功', // 业务办理时的每个办理步骤。（页面浏览、输入姓名(点击输入框时触发）、输入联系电话(点击输入框时触发）、输入身份证(点击输入框时触发）、选择收货省/市（选择成功后触发）、选择号码归属（选择成功后触发）、选择号码（选择号码成功后触发）、选择收货地址（选择成功后触发）、填写详细地址(点击输入框时触发）、提交订单、提交订单成功、提交订单失败......）
                channelId_var: data.data?.channelId_var, // 下单渠道编码
                operatorId_var: data.data?.operatorId, // 下单工号
                merchantsOrder_var: data.data?.merchantsOrder_var, // 自建的订单号。
                orderNumber_var: data.data?.orderNumber_var, // 能开接口返回的订单号。
              })
            );
          }
          submitXzPageCode('99', '办理成功');
        } else {
          submitXzPageCode('-99', '办理失败');
          return setmessageDialogShow(data.msg ?? '提交失败');
        }
      } catch (e: any) {
        return showToast(submitOverTips);
      } finally {
        loading = false;
      }
    } else {
      // =================================支付订单===================================
      // if (!isWeixinEnv()) {
      //   return showToast('请在微信中打开页面');
      // }
      if (isWeixinEnv() && payType !== 'jsd_h5_ali') {
        // if (!wxReady || !main.openId) {
        //   return showToast('微信支付初始化失败，请刷新重试');
        // }
      }
      try {
        let res = await apiPayAndSubmitOrder({
          openId: main.openId,
          appId: main.appId,
          payType: payType,
          clientOrderBo: orderData,
          shopNum,
        });
        let data = res.data;
        if (data.code === 200) {
          let _data = data.data;
          let payRes = await showPayPage(_data, payType);
          if (payRes.code === 200) {
            submitXzPageCode('99', '办理成功');
            submitOverTips = payRes.msg ?? '提交成功';
            if (!!_data?.supUrl) {
              window.location.replace(_data?.supUrl);
            } else {
              navigate('/submit', { state: submitOverTips });
            }
          } else if (payRes.code === 300) {
            window.location.href = payRes.url;
          } else if (payRes.code === 400) {
            await showConfirm({
              title: '提示',
              content: '是否支付完成?',
              confirmBtnText: '支付完成',
              cancelBtnText: '未完成',
              onConfirm: () => { },
              onCancel: () => { },
            });
          } else {
            showToast(payRes.msg);
          }
        } else {
          submitXzPageCode('-99', '办理失败');
          if (goodsDetail?.supId === main.supId) {
            window.gdp(
              'track',
              'merchants_bussinessProcessing',
              Object.assign({}, insertCode, {
                goodsId_var: goodsDetail?.skuCode, // 业务办理时所属的商品ID。（需与能开商品编码一致）
                goodsName_var: goodsDetail?.skuName, //业务办理时商品名称。
                contactNumber_var: aesPhone, //联系电话(AES加密后的手机号),传用户的联系电话
                processType_var: '提交订单', // 业务办理时的每个办理步骤。（页面浏览、输入姓名(点击输入框时触发）、输入联系电话(点击输入框时触发）、输入身份证(点击输入框时触发）、选择收货省/市（选择成功后触发）、选择号码归属（选择成功后触发）、选择号码（选择号码成功后触发）、选择收货地址（选择成功后触发）、填写详细地址(点击输入框时触发）、提交订单、提交订单成功、提交订单失败......）
                errorMessage_var: data.msg, // 业务办理失败时的失败原因明细。（网络问题、业务互斥……）
              })
            );
          }
          return setmessageDialogShow(data.msg ?? '提交失败');
        }
      } catch (e: any) {
        submitOverTips = e.message ?? '提交失败';
        return showToast(submitOverTips);
      } finally {
        loading = false;
      }
    }
    setSelectCard(undefined);
    setCardName('');
    setCardNum('');
    setPhone('');
    setAddress('');
    setCardAvatar('');
    setNationalEmblem('');
    setHandPhoto('');
  }
  // 存量提交
  async function handleSubmitCL() {
    if (!phone) {
      return showToast('请输入收件人手机号');
    }
    if (!verifyCode) {
      return showToast('请输入验证码');
    }
    try {
      let res = await apiMarketOfferOrder({
        phoneNum: phone,
        verifyCode: verifyCode,
        goodsCode: goodsDetail?.goodsCode,
        orderSn: smsKey,
      });
      let data = res.data;
      if (data.code === 200) {
        showToast('提交成功');
        setPhone('');
        setVerifyCode('');
        setSendCaptcha(0);
      } else {
        setmessageDialogShow(data.msg ?? '提交失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '提交失败');
    }
  }
  // 发送验证码
  async function getSendCaptcha() {
    let telReg = /^1[3-9]{1}[0-9]{9}$/;
    if (!telReg.test(phone)) {
      return showToast('手机号格式不正确');
    }
    try {
      let res = await apiMarketVerifyCode(phone, goodsDetail!.goodsCode);
      let data = res.data;
      if (data.code === 200) {
        if (data?.data?.orderId) {
          setSmsKey(data.data.orderId);
        }
        if (ref.current.timer) {
          clearInterval(ref.current.timer);
        }
        ref.current.count = 60;
        ref.current.timer = setInterval(() => {
          ref.current.count! -= 1;
          setSendCaptcha(ref.current.count!);
          if (ref.current.count! <= 0) {
            clearInterval(ref.current.timer);
          }
        }, 1000);
        showToast('发送成功');
      } else {
        let msg =
          goodsDetail?.goodsType === 'market' && goodsDetail?.supId === '1729792961245667330'
            ? data.data.tipsMsg
            : data.msg;
        setmessageDialogShow(msg ?? '发送失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '发送失败');
    }
  }

  function handleDetailRef(v?: HTMLDivElement | null) {
    if (v) {
      let imgList = v.getElementsByTagName('img');
      if (imgList.length) {
        for (let i = 0; i < imgList.length; i++) {
          let img = imgList.item(i);
          if (img) {
            let url = img.getAttribute('data-href');
            if (url) {
              if (!url?.startsWith('http')) {
                //不是http开头的 跳转到固定页面并传参数
                let tmp = protocolData.find((i) => i.value === url);
                if (tmp) {
                  img.onclick = () => navigate('/protocol', { state: url });
                }
              } else {
                // 是HTTP开头的 跳转走
                if (!img.onclick) {
                  img.onclick = () => window.open(url!, '_blank', 'noopener,noreferrer');
                }
              }
            }
          }
        }
      }
    }
  }
  function changeVideo(event: any) {
    const video: any = document.getElementById('videoPlayer');
    let isVideoPlaying = !video.paused && !video.ended && video.readyState > 2;
    setIsVideoPlaying(isVideoPlaying);
    if (isVideoPlaying) {
      video.pause();
    } else {
      video.play();
    }
  }
  function handleCopyHost() {
    let param = parseLocationParams(location.search);
    let url = window.location.href;
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    if (!param?.sn && !!landingCode) {
      url = window.location.href + `&sn=${shopNum}`;
    }
    copyToClipboard(url);
  }
  // 上传照片
  const chooseImg = async (t: FileList | null, type: string) => {
    if (t && t[0]) {
      if (t[0].size / 1024 / 1024 > 10) return showToast('照片不可以上传超过10MB');
      setuploadLoading(true);
      try {
        const res = await apiOssUpload(t[0]);
        if (res) {
          if (type === 'cardAvatar') {
            setCardAvatar(res);
          } else if (type === 'cardNationalEmblem') {
            setNationalEmblem(res);
          } else if (type === 'handPhoto') {
            setHandPhoto(res);
          } else if (type === 'definedPhotoImg') {
            setdefinedPhotoImg(res);
          }
        }
      } catch (error) {
      } finally {
        setuploadLoading(false);
      }
    }
  };
  // 广东移动插码输入框开始----
  const handChangeIpt = (type: string) => {
    if (main.supId === goodsDetail?.supId) {
      window.gdp(
        'track',
        'merchants_bussinessProcessing',
        Object.assign({}, insertCode, {
          goodsId_var: goodsDetail?.skuCode, // 业务办理时所属的商品ID。（需与能开商品编码一致）
          goodsName_var: goodsDetail?.skuName, //业务办理时商品名称。
          contactNumber_var: aesPhone ? aesPhone : '', //输入电话号码,传AES加密后的手机号
          processType_var: type, // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
        })
      );
    }
  };
  // 广东移动插码输入框结束----
  // 获取加密手机号
  async function getStockAesPhone(tel: string) {
    if (main.supId === goodsDetail?.supId) {
      let res = await apiEncryption({ msgs: tel });
      if (res.code === 200) {
        setaesPhone(res?.data[tel]);
      } else {
        showToast('请检查手机号是否正确');
      }
    }
  }
  // 分享链接
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function handGoodsLandingPageLink() {
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    let res = await apiGoodsLandingPageLink({
      goodsCode: goodsDetail?.goodsCode,
      uc: urlQueryParams?.uc,
      sn: urlQueryParams?.sn ?? shopNum,
    });
    let data = res.data;
    if (data.code === 200) {
      setshareUrl(data?.data ?? window.location.href);
    } else {
      showToast(data?.msg ?? '网络繁忙，请稍后再试...');
    }
  }
  // 跳转客服
  function handleServiceLink() {
    const url = getSafeLandingLink(landingCode ? main.serviceLink : goodsDetail?.serviceUrl);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }
  if (loadError || !goodsDetail || detailerrorMsg) {
    return (
      <Page
        style={Object.assign({}, main.pageBgStyle, { popGesture: 'none' })}
        className="detail-page d-flex-c"
        contentClassName="flex-1 h-1 overflow-y"
        appBar={<AppBar className="bg-transparent" title="商品详情" />}
      >
        {!goodsDetail && !loadError && !detailerrorMsg ? (
          <Loading tips={'正在加载中...'} />
        ) : (
          <Empty
            className="emptybox"
            pic={detailerrorMsg ? '/pic/bg_error.png' : '/pic/pic_not_found.png'}
            tips={detailerrorMsg ?? 'Page not found...'}
          />
        )}
      </Page>
    );
  }
  const excludeRegions = {
    provinces: !!goodsDetail.stopProvince ? goodsDetail.stopProvince : [],
    cities: !!goodsDetail.stopCity ? goodsDetail.stopCity : [],
    district: !!goodsDetail.stopCounty ? goodsDetail.stopCounty : [],
  };
  // 特定商品只展示收件号码输入框
  let isSimpleMode = ['zrDPlfa2TJ', 'JFibR6UuGv', 'ErGENCAyLk', 'WLJc2EN28m'].includes(urlQueryParams.id);
  let uc = main?.uc;
  let url = `${main.shopId ? '?code=' + main.shopId : ''}`;
  let _url = url + `${uc ? '&uc=' + uc : ''}`;
  // 微信支付复制链接
  let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
  let wxPayUrl = window.location.href;
  if (!urlQueryParams?.sn && !!landingCode) {
    wxPayUrl = window.location.href + `&sn=${shopNum}`;
  }
  if (isExpired) {
    return (
      <Page
        style={Object.assign({}, main.pageBgStyle, { popGesture: 'none' })}
        className="detail-page d-flex-c"
        contentClassName="flex-1 h-1 overflow-y"
        appBar={<AppBar className="bg-transparent" title="商品详情" />}
      >
        <Empty className="emptybox" pic="/pic/bg_error.png" tips="链接已失效" />
      </Page>
    );
  }
  let goodsInfo = {
    id: goodsDetail?.id,
    name: goodsDetail?.goodsName,
    goodsHeadImg: goodsDetail?.goodsHeadImg,
    price: Number(goodsDetail?.goodsPrice ?? 0), // 0元则改为0
    link: window.location.href, // 当前下单页面链接
    logoUrl: '/pic/icon_logo.png', // 替换为你的logo地址
  };
  let submitBtnTxt = goodsDetail?.priceRemark
    ? goodsDetail?.priceRemark
    : goodsDetail.paySwitch === 'Y' || Number(goodsDetail?.carryPrice) !== 0
      ? '立即购买'
      : '立即领取';
  return (
    <Page
      style={Object.assign({}, { backgroundColor: '#f1f1f1' }, { popGesture: 'none' })}
      className="detail-page d-flex-c"
      contentClassName="flex-1 h-1 d-flex-c"
      appBar={
        hideAppBar
          ? undefined
          : !!landingCode && (
            <AppBar
              showBack={!!main.shopId}
              onBack={() => (state === 'search' ? navigate('/search') : navigate(`/${_url}`))}
              className="bg-transparent"
              title={
                goodsDetail?.operatorsType && !goodsDetail?.operatorsType?.includes(',')
                  ? dictLabel(goodsDetail?.operatorsType, operatorsTypeData) + '通信专营授权店'
                  : '商品详情'
              }
            />
          )
      }
    >
      {goodsDetail?.goodsCode === 'UBo9yCCb4m' && (
        <Helmet>
          <title>郑州迅海</title>
        </Helmet>
      )}
      <div className="flex-1 h-1 overflow-y mb-70">
        <img className="head-img overflow-hidden box-shadow" src={goodsDetail!.goodsHeadImg} alt="" />
        {/* 标题盒子 */}
        <div className="p-12 bg-white">
          {!isSimpleMode && (
            <div className="d-flex-r ai-center jc-between">
              <div className="font-size-24 font-widget-600 text-color-p">
                <span className="font-size-16 mr-3">¥</span>
                {Number(goodsDetail?.goodsPrice ?? 0).toFixed(2)}
              </div>
              <div className="text-color-9 font-size-12">已售{goodsDetail?.goodsSales ?? 0}</div>
            </div>
          )}
          <div className="mt-8">
            {goodsDetail?.goodsType !== 'equipment' && goodsDetail?.operatorsType && (
              <img className="vertical-top mr-4 w-64 h-20" src={`/pic/icon_${goodsDetail?.operatorsType}.png`} alt="" />
            )}
            <div className="d-inline font-size-18 text-color-3 font-widget-600 line-height-24">
              {goodsDetail?.goodsName}
            </div>
          </div>
        </div>
        {/* 上传信息盒子 */}
        <div className="main-block pl-12 pr-12 pt-8 pb-8 bg-white mt-10">
          {!isSimpleMode && (
            <>
              <div className="main-title pos-r ml-4 mb-8 font-size-16 font-widget-600 line-height-24">
                <div className="pos-r zIdx-10">邮寄信息</div>
                <div className="line pos-a l-0"></div>
              </div>
              {goodsDetail?.goodsType !== 'equipment' && (
                <>
                  <div className="text-color-6 mb-4 font-size-12">
                    *请填写真实身份信息，年龄不符、一证五号、信息错误将无法发货。(所填信息皆做加密处理)
                  </div>
                  <div className="text-color-6 mb-4 font-size-12">*禁止用电话卡参与任何违法事件</div>
                </>
              )}
            </>
          )}
          {/* 商品类型为存量 只需要提交手机号与验证码 */}
          {isSimpleMode ? (
            <div className="form-block mt-8">
              <div className="prop-line mb-12 d-flex-r ai-center">
                <div className="label">联系电话</div>
                <div className="value border-bottom flex-1">
                  <input
                    id="tellphone"
                    disabled={goodsDetail.goodsStatus === 'stop_sale'}
                    className="input"
                    placeholder="联系电话"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                      handChangeIpt('输入联系电话');
                      if (e.target.value.length === 11) getStockAesPhone(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : goodsDetail.goodsType === 'market' ? (
            <div className="form-block mt-8">
              <div className="prop-line mb-12 d-flex-r ai-center">
                <div className="label">手机号</div>
                <div className="value border-bottom flex-1">
                  <input
                    disabled={goodsDetail.goodsStatus === 'stop_sale'}
                    className="input"
                    placeholder="请输入收件手机号"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>
              <div className="prop-line mb-12 d-flex-r ai-center">
                <div className="label">验证码</div>
                <div
                  className={`value border-bottom flex-1 d-flex-r ${goodsDetail.goodsStatus === 'stop_sale' ? 'bg-ccc' : ''
                    }`}
                >
                  <input
                    disabled={goodsDetail.goodsStatus === 'stop_sale'}
                    className="flex-1 input"
                    placeholder="请输入验证码"
                    value={verifyCode}
                    onChange={(e) => setVerifyCode(e.target.value)}
                  />
                  {goodsDetail.goodsStatus === 'stop_sale' ? (
                    <div className="verify-btn" style={{ background: '#ccc' }}>
                      发送
                    </div>
                  ) : (
                    <div
                      className={`verify-btn ${sendCaptcha > 0 && 'disable-verify-btn'}`}
                      onClick={() => {
                        sendCaptcha > 0 ? showToast('短信正在发送，请稍等') : getSendCaptcha();
                      }}
                    >
                      {sendCaptcha > 0 ? `${sendCaptcha}s` : '发送'}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : isSimpleMode ? (
            <div className="form-block mt-8">
              <div className="prop-line mb-12 d-flex-r ai-center">
                <div className="label">收件号码</div>
                <div className="value border-bottom flex-1">
                  <input
                    id="tellphone"
                    disabled={goodsDetail.goodsStatus === 'stop_sale'}
                    className="input"
                    placeholder="收货手机号码(已加密)"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                      handChangeIpt('输入联系电话');
                      if (e.target.value.length === 11) getStockAesPhone(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="form-block mt-8">
              {goodsDetail?.goodsType === 'order_subscribe' && (
                <div className="prop-line mb-12 d-flex-r ai-center">
                  <div className="label">开卡号码</div>
                  <div className="value border-bottom flex-1">
                    <input
                      disabled={goodsDetail.goodsStatus === 'stop_sale'}
                      className="input"
                      placeholder="请输入开卡号码"
                      value={activatePhone}
                      onChange={(e) => {
                        setactivatePhone(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="prop-line mb-12 d-flex-r ai-center">
                <div className="label">
                  {goodsDetail?.goodsType !== 'order_subscribe' ? '收件人姓名' : '身份证姓名'}
                </div>
                <div className="value border-bottom flex-1">
                  <input
                    disabled={goodsDetail.goodsStatus === 'stop_sale'}
                    className="input"
                    placeholder="与身份证上的姓名一致(已加密)"
                    value={cardName}
                    onChange={(e) => {
                      setCardName(e.target.value);
                      handChangeIpt('输入姓名');
                    }}
                  />
                </div>
              </div>
              {(goodsDetail?.goodsType === 'order' ||
                goodsDetail?.goodsType === 'order_subscribe' ||
                goodsDetail?.goodsType === 'broadband') && (
                  <div className="prop-line mb-12 d-flex-r ai-center">
                    <div className="label">身份证号</div>
                    <div className="value border-bottom flex-1">
                      <input
                        disabled={goodsDetail.goodsStatus === 'stop_sale'}
                        className="input"
                        placeholder="(已加密，仅用于本次业务)"
                        value={cardNum}
                        onChange={(e) => {
                          setCardNum(e.target.value);
                          handChangeIpt('输入身份证');
                        }}
                      />
                    </div>
                  </div>
                )}
              {goodsDetail?.goodsType !== 'order_subscribe' && (
                <>
                  <div className="prop-line mb-12 d-flex-r ai-center">
                    <div className="label">收件号码</div>
                    <div className="value border-bottom flex-1">
                      <input
                        id="tellphone"
                        disabled={goodsDetail.goodsStatus === 'stop_sale'}
                        className="input"
                        placeholder="收货手机号码(已加密)"
                        value={phone}
                        onChange={(e) => {
                          setPhone(e.target.value);
                          handChangeIpt('输入联系电话');
                          if (e.target.value.length === 11) getStockAesPhone(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="prop-line mb-12 d-flex-r ai-center">
                    <div className="label">城市选择</div>
                    <div className="value border-bottom flex-1">
                      <MCityPicker
                        matchList={matchList}
                        disable={goodsDetail.goodsStatus === 'stop_sale'}
                        onChange={handleCityPickerChange}
                        someProvince={goodsDetail!.localAddress ?? []}
                        excludeRegions={excludeRegions}
                        subProvince={!!goodsDetail.subProvince ? goodsDetail.subProvince : []}
                        provinceName={province}
                        cityName={city}
                        countyName={area}
                      />
                    </div>
                  </div>
                  <div className="prop-line mb-12 d-flex-r ai-center">
                    <div className="label">详细地址</div>
                    <div className="value border-bottom flex-1">
                      <input
                        disabled={goodsDetail.goodsStatus === 'stop_sale'}
                        className="input"
                        placeholder="街道/镇+村庄/小区/写字楼+门牌号"
                        value={address}
                        onChange={(e) => {
                          setAddress(e.target.value);
                          handChangeIpt('填写详细地址');
                        }}
                        onBlur={(e) => {
                          if (!!e.target.value) {
                            isChinaMobileGoods();
                          }
                        }}
                      />
                    </div>
                  </div>
                  {!!productId && goodsDetail?.supId === '1816357513598500865' && (
                    <div className="prop-line mb-5 d-flex-r ai-center">
                      <div className="label"></div>
                      <div className="flex-1 text-color-red">
                        单一地址中禁止含有:酒吧、宾馆、超市、门卫、开发区、经济开发区、园、大厦、写字楼、酒店、网、茶、游戏厅、台球厅、美容院、饭馆、住所、娱乐性场所、初中，小学、幼儿园等地址为学校、附近、旁边、东西南北、物流、快递、代收点等信息会进行订单拦截，请谨慎下单!
                      </div>
                    </div>
                  )}
                  {Number(goodsDetail!.carryPrice) > 0 && (
                    <div className="prop-line mb-5 d-flex-r ai-center">
                      <div className="label font-size-12">运费：</div>
                      <div className="value border-bottom flex-1 font-size-12 text-color-red">
                        商品运费需￥{goodsDetail!.carryPrice}
                      </div>
                    </div>
                  )}
                </>
              )}
              {operatorsList.length > 0 && goodsDetail?.goodsType && goodsDetail?.goodsType !== 'order' && (
                <div className="prop-line mb-5 d-flex-r ai-center">
                  <div className="label">运营商</div>
                  <div className="value border-bottom flex-1">
                    <MSelectbox
                      disable={goodsDetail.goodsStatus === 'stop_sale'}
                      title="运营商选择"
                      onChange={(v) => v && setoperatorsType(v[0].value)}
                      someProvince={operatorsList}
                      defaultVal={operatorsList[0]?.label}
                    ></MSelectbox>
                  </div>
                </div>
              )}
              {goodsDetail!.ifCampOn === 'Y' && (
                <div className="prop-line mb-12 d-flex-r ai-center">
                  <div className="label">在线选号</div>
                  <div
                    className={`value border-bottom flex-1 ${selectCard ? '' : 'text-color-9'}  
                  ${goodsDetail.goodsStatus === 'stop_sale' ? 'bg-555 pl-10' : ''}`}
                    onClick={() => {
                      if (goodsDetail!.ifAddress === 'Y' && !province) {
                        showToast('请先选择城市');
                        return;
                      }
                      setShowSelectCardDialog(true);
                    }}
                  >
                    {selectCard?.activatePhone || (goodsDetail!.ifAddress === 'Y' ? '需要先选择城市' : '请选择号码')}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div
          className={`${(goodsDetail!.ifPhoto === 'Y' || goodsDetail?.isDefinedPhoto === 'Y') &&
            'main-block pl-12 pr-12 pt-8 pb-8 bg-white mt-10'
            }`}
        >
          {!isSimpleMode && goodsDetail!.ifPhoto === 'Y' && (
            <div>
              <div className="main-title pos-r ml-4 mb-8 font-size-16 font-widget-600 line-height-24">
                <div className="pos-r zIdx-10">上传身份信息</div>
                <div className="line pos-a l-0"></div>
              </div>
              <div className="text-color-6 font-size-14">根据有关部门要求，必须上传真实身份证照片。</div>
              <span className="text-color-red mb-8 font-size-12">未上传照片，订单无效</span>
              <div className="mt-10">
                <div className="prop-line d-flex-r ai-center">
                  <div className="flex-1 pic pb-5 d-flex-r">
                    {cardAvatar ? (
                      <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                        <img
                          className="bw-100"
                          src={cardAvatar}
                          alt=""
                          onClick={() => setviewPictureDialogShow(cardAvatar)}
                        />
                        <div className="icon-close-block" onClick={() => setCardAvatar(undefined)}>
                          <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center ${goodsDetail.goodsStatus === 'stop_sale' && 'bg-555'
                          }`}
                      >
                        <div className="flex-1 d-flex-c ai-center jc-center">
                          <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                          <div className="upload-label font-size-12">
                            拍摄身份证<span className="text-color-p">人像</span>所在面
                          </div>
                        </div>
                        <input
                          disabled={goodsDetail.goodsStatus === 'stop_sale'}
                          className="upload-input bw-100 bh-100"
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          onChange={(e) => {
                            chooseImg(e.target.files, 'cardAvatar');
                          }}
                        />
                      </div>
                    )}
                    <div className="example-block">
                      <img
                        onClick={() => setviewPictureDialogShow('/pic/iccid1.png')}
                        className="example-img"
                        src="/pic/iccid1.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <span className="font-size-12 upload-label">
                  手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
                </span>
              </div>
              <div className="mt-16">
                <div className="prop-line d-flex-r ai-center">
                  <div className="flex-1 pic pb-5 d-flex-r">
                    {cardNationalEmblem ? (
                      <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                        <img
                          className="bw-100"
                          src={cardNationalEmblem}
                          alt=""
                          onClick={() => setviewPictureDialogShow(cardNationalEmblem)}
                        />
                        <div className="icon-close-block" onClick={() => setNationalEmblem(undefined)}>
                          <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center ${goodsDetail.goodsStatus === 'stop_sale' && 'bg-555'
                          }`}
                      >
                        <div className="flex-1 d-flex-c ai-center jc-center">
                          <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                          <div className="upload-label font-size-12">
                            拍摄身份证<span className="text-color-p">国徽</span>所在面
                          </div>
                        </div>
                        <input
                          disabled={goodsDetail.goodsStatus === 'stop_sale'}
                          className="upload-input bw-100 bh-100"
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          onChange={(e) => {
                            chooseImg(e.target.files, 'cardNationalEmblem');
                          }}
                        />
                      </div>
                    )}
                    <div className="example-block">
                      <img
                        className="example-img"
                        onClick={() => setviewPictureDialogShow('/pic/iccid2.png')}
                        src="/pic/iccid2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <span className="font-size-12 upload-label">
                  手机横拍，保证边角完整信息清晰，不能反光、翻拍、模糊、边角残缺等。
                </span>
              </div>
              <div className="mt-16">
                <div className="prop-line d-flex-r ai-center">
                  <div className="flex-1 pic pb-5 d-flex-r">
                    {handPhoto ? (
                      <div className="upload-pic border-radius-4 overflow-hidden mr-5">
                        <img
                          className="bw-100"
                          src={handPhoto}
                          alt=""
                          onClick={() => setviewPictureDialogShow(handPhoto)}
                        />
                        <div className="icon-close-block" onClick={() => setHandPhoto(undefined)}>
                          <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`upload-pic border border-radius-8 text-center d-flex-r ai-center jc-center ${goodsDetail.goodsStatus === 'stop_sale' && 'bg-555'
                          }`}
                      >
                        <div className="flex-1 d-flex-c ai-center jc-center">
                          <img className="w-60 h-60" src="/pic/icon_shoot.png" alt="" />
                          <div className="upload-label font-size-12">拍摄正面免冠人像</div>
                        </div>
                        <input
                          disabled={goodsDetail.goodsStatus === 'stop_sale'}
                          className="upload-input bw-100 bh-100"
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          onChange={(e) => {
                            chooseImg(e.target.files, 'handPhoto');
                          }}
                        />
                      </div>
                    )}
                    <div className="example-block">
                      <img
                        className="example-img"
                        onClick={() => setviewPictureDialogShow('/pic/iccid3.png')}
                        src="/pic/iccid3.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <span className="font-size-12 upload-label">
                  请拍摄本人真实环境清晰正面免冠人像，不能反光，有水印，PS、上传证件照等。
                </span>
              </div>
            </div>
          )}
          {/* 上传自定义图片 */}
          {!isSimpleMode && goodsDetail?.isDefinedPhoto === 'Y' && (
            <div className="mt-16">
              <div className="d-flex-r ai-center mb-8">
                <div
                  className="upload-pic upload-customize-block customize-block border-radius-8 text-center d-flex-r ai-center jc-center"
                  onClick={() => {
                    if (!(goodsDetail?.definedPhotoUrl ?? '').includes('http')) return;
                    window.location.href = goodsDetail?.definedPhotoUrl;
                  }}
                >
                  <div className="flex-1 d-flex-c ai-center jc-center text-color-white">
                    <div className="font-size-12 font-widget-600">第一步</div>
                    <img className="w-48 h-48 mt-12 mb-12" src="/pic/icon_detail_search.png" alt="" />
                    <div className="w-100 font-size-10 omit-text">
                      {goodsDetail?.supId === '2005813192906031106' ? '查看示例图' : goodsDetail?.definedPhotoDesc}
                    </div>
                  </div>
                </div>
                <div className="w-110 prop-line d-flex-r ai-center ml-12">
                  <div className="bw-100 h-126 d-flex-r ai-center jc-center">
                    {definedPhotoImg ? (
                      <div className="upload-pic upload-customize border-radius-4 overflow-hidden mr-5">
                        <img
                          className="bw-100"
                          src={definedPhotoImg}
                          alt=""
                          onClick={() => setviewPictureDialogShow(definedPhotoImg)}
                        />
                        <div className="icon-close-block" onClick={() => setdefinedPhotoImg(undefined)}>
                          <img className="bw-100 bh-100" src="/pic/icon_close.png" alt="" />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`upload-pic upload-customize-block border border-radius-8 text-center d-flex-r ai-center jc-center ${goodsDetail.goodsStatus === 'stop_sale' && 'bg-555'
                          }`}
                      >
                        <div className="flex-1 d-flex-c ai-center jc-center">
                          <div className="font-size-12 font-widget-600 upload-label">第二步</div>
                          <img className="w-60 h-60 mt-5 mb-5" src="/pic/icon_shoot.png" alt="" />
                          <div className="upload-label font-size-10">
                            {goodsDetail?.supId === '2005813192906031106' ? '上传骑手证明' : '上传截图'}
                          </div>
                        </div>
                        <input
                          disabled={goodsDetail.goodsStatus === 'stop_sale'}
                          className="upload-input bw-100 bh-100"
                          type="file"
                          accept=".jpg,.png,.jpeg"
                          onChange={(e) => {
                            chooseImg(e.target.files, 'definedPhotoImg');
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {goodsDetail?.supId !== '2005813192906031106' && (
                  <div className="example-block upload-customize-block">
                    <img
                      onClick={() =>
                        setviewPictureDialogShow(
                          goodsDetail?.definedPhotoImg ? goodsDetail?.definedPhotoImg : '/pic/iccid4.png'
                        )
                      }
                      className="example-img"
                      src={goodsDetail?.definedPhotoImg ? goodsDetail?.definedPhotoImg : '/pic/iccid4.png'}
                      alt=""
                    />
                  </div>
                )}
              </div>
              <span className="font-size-12 upload-label">{goodsDetail?.definedPhotoDesc}</span>
            </div>
          )}
        </div>
        {/* 协议盒子 */}
        {!isSimpleMode && (
          <div className="d-flex-r mb-10 bg-white pl-12 pr-12 pb-12">
            <MCheckbox value={checkProtocol} onChange={(v) => setCheckProtocl(v)} />
            <div className="ml-4 font-size-12">
              <span className="text-color-9" onClick={() => setCheckProtocl(!checkProtocol)}>
                我已阅读并同意
              </span>
              {/* 联通隐私协议 */}
              {goodsDetail?.operatorsType === 'unicom' && (
                <>
                  <span className="text-color-p" onClick={() => setShowProtocol('ltUser1')}>
                    《中国联通客户入网服务协议》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('ltUser2')}>
                    《中国联通用户隐私政策》
                  </span>
                  <span
                    className="text-color-p"
                    onClick={() => {
                      settitle('实名制流程');
                      setviewPictureDialogShow('/pic/real_name.jpg');
                    }}
                  >
                    《实名制流程》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('ltUser3')}>
                    《中国联通儿童个人信息保护政策及监护人须知》
                  </span>
                </>
              )}
              {goodsDetail.supId === '1667093255927742465' ? (
                <>
                  {/* 广东移动隐私协议 */}
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd1')}>
                    《电信网络诈骗犯罪及发送不良信息法律责任风险提示告知书》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd2')}>
                    《电子渠道开户服务协议》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd3')}>
                    《中国移动广东公司电子渠道商品销售服务协议》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd4')}>
                    《校园客户新入网优惠协议》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd5')}>
                    《中国移动通信客户服务协议》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd6')}>
                    《解约条款》
                  </span>
                  <span className="text-color-p" onClick={() => setShowProtocol('gdyd7')}>
                    《隐私政策》
                  </span>
                </>
              ) : goodsDetail?.supId === '1957715627849629698' ? (
                <>
                  {/* 西藏移动隐私协议 */}
                  {xzProtocolList.map((item, idx) => (
                    <span key={idx} onClick={() => setxzprotocolcontent(item)} className="text-color-p">
                      《{item.protocolName}》
                    </span>
                  ))}
                </>
              ) : protocolFlag && !!province && !!privacyAgreementData.length ? (
                <>
                  {/* 中移号卡的隐私协议-请求的接口 */}
                  {privacyAgreementData.map((item, idx: number) => (
                    <span className="text-color-p" onClick={() => setprotocolcontent(item)} key={item.protocolName + idx}>
                      《{item.protocolName}》
                    </span>
                  ))}
                </>
              ) : (
                <>
                  {protocolFlag ? (
                    <span className="text-color-p" onClick={() => setShowProtocol('zyUserInfo')}>
                      《关于客户个人信息收集、使用规则的公告》
                    </span>
                  ) : (
                    <span className="text-color-p" onClick={() => setShowProtocol('userInfo')}>
                      《关于客户个人信息收集、使用规则的公告》
                    </span>
                  )}
                  {goodsDetail.operatorsType === 'telecom' && goodsDetail?.isZsDx !== 'Y' && (
                    <span className="text-color-p" onClick={() => setShowProtocol('noticeDX')}>
                      《中国电信用户入网协议》
                    </span>
                  )}

                  {goodsDetail.operatorsType === 'telecom' && goodsDetail?.isZsDx === 'Y' && (
                    <>
                      <span className="text-color-p" onClick={() => setShowProtocol('zhouShanDX')}>
                        《中国电信用户入网协议（2024 线上版）》
                      </span>
                      <span className="text-color-p" onClick={() => setShowProtocol('zhouShanruwangDX')}>
                        《用户入网补充告知书-2024版》
                      </span>
                    </>
                  )}
                  <span className="text-color-p" onClick={() => setShowProtocol('phone')}>
                    《办理电话号码开户法律风险及防范提示告知书》
                  </span>
                  {goodsDetail.operatorsType === 'cmcc' && (
                    <span className="text-color-p" onClick={() => setShowProtocol('noticeYD')}>
                      《关于客户个人信息收集、使用及保护的公告》
                    </span>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {(goodsDetail.paySwitch === 'Y' || Number(goodsDetail?.carryPrice) > 0) && (
          <div className="main-block form-block bg-white p-10">
            <div className="main-title pos-r ml-4 mb-8 font-size-16 font-widget-600 line-height-24">
              <div className="pos-r zIdx-10">选择支付方式</div>
              <div className="line pos-a l-0"></div>
            </div>
            {payConfigList.map((i, idx) => (
              <div key={idx} className="d-flex-r ai-center mt-14">
                <img src={`/pic/${PayType.typeIcon(i.payType)}`} className="icon-20 mr-10" alt="" />
                <div className="flex-1">{i.name}</div>

                <MCheckbox value={i.payType === payType} onChange={() => setPayType(i.payType)} />
              </div>
            ))}
            {!isWeixinEnv() && (
              <div className="mt-10">
                <span className="font-size-12 text-color-6">如需微信支付，请复制链接到微信打开即可！</span>
                <div
                  className="bg-p w-100 border-radius-4 text-color-white pt-5 pb-5 text-center mt-5"
                  onClick={handleCopyHost}
                >
                  复&nbsp;制
                </div>
              </div>
            )}
          </div>
        )}
        <div className="bg-white mt-10 mb-10">
          {!!goodsDetail?.videoUrl && (
            <div className="video-box" onClick={changeVideo}>
              <video
                width="100%"
                id="videoPlayer"
                // autoPlay
                webkit-playsinline="true"
                playsInline={true}
                // controls
                poster={!!isVideoPlaying ? goodsDetail!.goodsHeadImg : ''}
              >
                <source src={goodsDetail?.videoUrl} type="video/mp4" />
              </video>
              {!!isVideoPlaying && <img className="video-img" src="/pic/icon-video.png" alt="" />}
            </div>
          )}
          <div className="main-block p-12">
            <div className="main-title pos-r ml-4 mb-8 font-size-16 font-widget-600 line-height-24">
              <div className="pos-r zIdx-10">产品详情</div>
              <div className="line pos-a l-0"></div>
            </div>
            <div
              className="goods-detail pb-8"
              ref={(v) => handleDetailRef(v)}
              dangerouslySetInnerHTML={{ __html: goodsDetail!.goodsDetail }}
            />
          </div>
        </div>
      </div>
      {goodsDetail.goodsStatus === 'stop_sale' ? (
        <div className="p-10 footer-btn">
          <div className="submit-btn d-flex-r ai-center jc-center" style={{ background: '#ccc' }}>
            该商品暂不可下单!
          </div>
        </div>
      ) : (
        <div className="bg-white p-10 footer-btn bw-100 text-color-6">
          {isSimpleMode ? (
            <div className="d-flex-r ai-center bw-100">
              <div className="font-size-12 d-flex-r">
                <div className="d-flex-c ai-center jc-center mr-30" onClick={() => navigate('/orderList')}>
                  <img src="/pic/icon_order.png" className="w-20 h-20 mb-3" alt="" />
                  <span className="font-widget-500">订单</span>
                </div>
                {!!(landingCode ? main.serviceLink : goodsDetail?.serviceUrl) && (
                  <div className="d-flex-c ai-center jc-center mr-30" onClick={handleServiceLink}>
                    <img src="/pic/icon_custom.png" className="w-20 h-20 mb-3" alt="" />
                    <span className="font-widget-500">客服</span>
                  </div>
                )}
              </div>
              <div className="flex-1 submit-btn d-flex-c ai-center jc-center font-size-14" onClick={handleSubmit}>
                {submitBtnTxt}
                {Number(goodsDetail?.liveTime ?? 0) > 0 && (
                  <CountdownTimer totalMilliseconds={goodsDetail?.liveTime} onExpire={() => setIsExpired(true)} />
                )}
              </div>
            </div>
          ) : goodsDetail.goodsType === 'market' ? (
            <div className="d-flex-r ai-center bw-100">
              <div className="font-size-12 d-flex-r">
                <div className="d-flex-c ai-center jc-center mr-30" onClick={() => navigate('/orderList')}>
                  <img src="/pic/icon_order.png" className="w-30 h-30 mb-3" alt="" />
                  <span className="font-widget-500">订单</span>
                </div>
                {!!(landingCode ? main.serviceLink : goodsDetail?.serviceUrl) && (
                  <div className="d-flex-c ai-center jc-center mr-30" onClick={handleServiceLink}>
                    <img src="/pic/icon_custom.png" className="w-30 h-30 mb-3" alt="" />
                    <span className="font-widget-500">客服</span>
                  </div>
                )}
              </div>
              <div className="flex-1 submit-btn d-flex-c ai-center jc-center" onClick={handleSubmitCL}>
                {submitBtnTxt}
                {/* 倒计时盒子 */}
                {Number(goodsDetail?.liveTime ?? 0) > 0 && (
                  <div className="">
                    <CountdownTimer totalMilliseconds={goodsDetail?.liveTime} onExpire={() => setIsExpired(true)} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="d-flex-r ai-center bw-100">
              <div className="font-size-12 d-flex-r">
                <div className="d-flex-c ai-center jc-center mr-30" onClick={() => navigate('/orderList')}>
                  <img src="/pic/icon_order.png" className="w-20 h-20 mb-3" alt="" />
                  <span className="font-widget-500">订单</span>
                </div>
                {!!(landingCode ? main.serviceLink : goodsDetail?.serviceUrl) && (
                  <div className="d-flex-c ai-center jc-center mr-30" onClick={handleServiceLink}>
                    <img src="/pic/icon_custom.png" className="w-20 h-20 mb-3" alt="" />
                    <span className="font-widget-500">客服</span>
                  </div>
                )}
                {(!!landingCode || !!urlQueryParams?.sn) && (
                  // <div className="d-flex-c ai-center jc-center mr-30" onClick={handGoodsLandingPageLink}>
                  //   <img src="/pic/icon_share.png" className="w-20 h-20 mb-3" alt="" />
                  //   <span className="font-widget-500">分享</span>
                  // </div>
                  <div className="d-flex-c ai-center jc-center mr-30" onClick={() => setsharePosterShow(goodsDetail)}>
                    <img src="/pic/icon_share.png" className="w-20 h-20 mb-3" alt="" />
                    <span className="font-widget-500">分享</span>
                  </div>
                )}
              </div>
              <div
                className="flex-1 submit-btn d-flex-c ai-center jc-center font-size-14"
                id="toApply"
                onClick={handleSubmit}
              >
                {goodsDetail.paySwitch === 'Y' || Number(goodsDetail?.carryPrice) !== 0
                  ? `${submitBtnTxt}${Number(goodsDetail.goodsPrice) > 0 ? `￥${goodsDetail.goodsPrice}` : ''}
                ${Number(goodsDetail?.carryPrice) !== 0 ? '+' : ''}
                 ${Number(goodsDetail?.carryPrice) !== 0 ? ` 运费￥${goodsDetail.carryPrice}` : ''}`
                  : submitBtnTxt}
                {/* 倒计时盒子 */}
                {Number(goodsDetail?.liveTime ?? 0) > 0 && (
                  <CountdownTimer totalMilliseconds={goodsDetail?.liveTime} onExpire={() => setIsExpired(true)} />
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {showProtocol && (
        <ProtocolDialog
          code={goodsDetail?.goodsCode}
          supName={goodsDetail!.supName}
          type={showProtocol}
          onClose={() => setShowProtocol(undefined)}
        />
      )}
      {!!protocolcontent && (
        <ZyProtocolDialog content={protocolcontent} onClose={() => setprotocolcontent(undefined)} />
      )}
      {!!xzprotocolcontent && (
        <XzprotocolDialog content={xzprotocolcontent} onClose={() => setxzprotocolcontent(undefined)} />
      )}
      {showSelectCardDialog && (
        <SelectPhoneDialog
          list={cardPool ?? []}
          value={selectCard}
          selectPhoneFlag={selectPhoneFlag}
          onChange={(v) => setSelectCard(v)}
          onClose={() => setShowSelectCardDialog(false)}
          onChangeNextPage={() => loadCardPool(goodsDetail?.goodsCode, province, city, area)}
        />
      )}
      {/* 接口500 返回的msg弹窗 */}
      {!!messageDialogShow && <MessageDialog message={messageDialogShow} onClose={() => setmessageDialogShow('')} />}
      {uploadLoading && (
        <Loading
          tips={'正在加载中...'}
          loadingClass="bh-100 overflow-hidden text-color-white d-flex-r ai-center jc-center mt-0 bg-shallow"
        />
      )}
      {/* 查看图片 */}
      {viewPictureDialogShow && (
        <ViewPictureDialog
          title={title}
          imgPath={viewPictureDialogShow}
          onClose={() => setviewPictureDialogShow(undefined)}
        />
      )}
      {/* 非微信环境内并且不支持支付宝收款且金额大于0 */}
      {!isWeixinEnv() && !payConfigList.length && Number(goodsDetail.goodsPrice ?? 0) > 0 && (
        <NotWxPageDialog
          iconShow={false}
          title="分享链接"
          confirmText="复制链接"
          content={wxPayUrl}
          tips="温馨提示：此链接需要在微信中打开，请点击复制链接到微信环境打开！"
          onClose={() => undefined}
        />
      )}
      {/* 分享链接 */}
      {!!shareUrl && (
        <NotWxPageDialog
          iconShow={false}
          cancelShow={true}
          title="分享链接"
          url={shareUrl}
          content={shareUrl}
          confirmText="复制链接"
          onClose={() => setshareUrl(undefined)}
        />
      )}
      {/* 温馨提示 */}
      {reminderDialogShow && (
        <ReminderDialog
          onClose={() => {
            setreminderDialogShow(false);
            let num = Number(sessionStorage.getItem('reminderDialogShow') ?? 0);
            sessionStorage.setItem('reminderDialogShow', (++num).toString());
          }}
        />
      )}
      {/* 海报分享 */}
      {sharePosterShow && (
        <GoodsShareModal visible={!!sharePosterShow} goods={goodsInfo} onClose={() => setsharePosterShow(undefined)} />
      )}
    </Page>
  );
}
